import styled from "styled-components";

export const customStyles = {
  overlay: {
    backgroundColor: "#00000170",
  },
  content: {
    border: "none",
    background: "none",
    padding: "0",
  },
};
export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const CloseButton = styled.button`
  position: absolute;
  top: calc(var(--u) * 10);
  right: calc(var(--u) * 10);
  background: none;
  border: none;
  font-size: calc(var(--u) * 50);
  color: #ccc;
  cursor: pointer;
`;
export const ModalContent = styled.div`
  display: flex;
  height: 70%;
  width: 45%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ModalHeader = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: ${(props) => props.color};
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;
export const Logo = styled.img`
  position: absolute;
  top: calc(var(--u) * 10);
  left: calc(var(--u) * 10);
  width: calc(var(--u) * 50);
  height: calc(var(--u) * 50);
`;
export const ModalTitle = styled.h1`
  width: 100%;
  font-size: var(--fs-2xl);
  font-weight: bold;
  text-align: center;
  margin-top: var(--sp-20);
  color: #fff;
`;
export const ModalDescription = styled.p`
  color: #fff;
  width: 100%;
  font-size: var(--fs-xl);
  text-align: center;
  margin-top: calc(var(--u) * 30);
  margin-bottom: var(--sp-10);
`;
export const ModalBody = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  background-color: ${(props) => props.color}; 
`;

export const DropdownInput = styled.div<{ color: string }>`
  width: calc(var(--u) * 200);
  font-size: var(--fs-lg);
  position: relative;
  left: 20%;
  border: 1px solid ${(props) => props.color};
  border-radius: 6px;
  margin: calc(var(--u) * 30);
  select {
    width: 100%;
    font-size: calc(var(--u) * 19.2);
    padding: var(--sp-4) var(--sp-2) var(--sp-2) var(--sp-4);
    border: 1px solid #bbbbbb;
    border-radius: 5px;
    outline: unset;
    transition: outline 0.2s ease;
  }

  select:focus {
    box-shadow: 0 0 0 1px #e8e8e8, 0 0 0 3px ${(props) => props.color};
  }

  label {
    padding: 0 var(--sp-5);
    transition: all 0.1s ease-in-out;
    position: absolute;
    top: 50%;
    right: calc(var(--u) * 10);
    transform: translateY(-50%);
    pointer-events: none;
    background: #ffffff;
    border-radius: 5px;
  }

  select:focus ~ label,
  select:not(:placeholder-shown) ~ label {
    top: calc(var(--u) * 10);
    right: calc(var(--u) * 10);
    transform: scale(0.85) translateY(-120%);
    background: ${(props) => props.color};
    color: white;
  }
`;
export const Button = styled.button`
  width: fit-content;
  height: calc(var(--u) * 40);
  background-color: white;
  color: black;
  border: none;
  border-radius: 12px;
  font-size: var(--fs-xl);
  font-weight: bold;
  cursor: pointer;
  padding: 0 var(--sp-20);
  margin: calc(var(--u) * 50);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:hover {
    opacity: 1;
  }
`;
export const ModalFooter = styled.div<{ color: string }>`
  position: relative;
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: space-between; // Change this from center to space-between
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background-color: ${(props) => props.color};
`;
